import fi from "./fi.json";

export type AllowedLanguagesType = "fi" | "en";

export const allowedLanguages: AllowedLanguagesType[] = ["fi", "en"];

export default {
  fi,
};
